import type { ITariffZone } from '../../../../models/tariff-zone.model';

export class TariffZoneApiModel {
  public static mapToBusinessModel(apiModel: TariffZoneApiModel): ITariffZone {
    return {
      number: apiModel.number,
      name: apiModel.name,
      shortName: apiModel.shortName,
    };
  }

  public gid!: string;
  public number!: number;
  public name!: string;
  public shortName!: string;
}
